//cos類似度の算出
function similarity(lab_vector, user_vector, setting_yaml){
    let inner_product = 0;
    let lab_square_sum = 0;
    let user_square_sum = 0;
    let ans = 0;

    //ベクトル長が可変の際に指定値のベクトル要素を追加する(指定値が無い場合は0.8とする)
    if (setting_yaml != null && setting_yaml.keyword_score_mode == 'COS_VECTOR_LENGTH_VARIABLE') {
        const additional_item_labo_value = setting_yaml. additional_item_labo_value;
        lab_square_sum = additional_item_labo_value ? additional_item_labo_value * additional_item_labo_value : 0.8 * 0.8;
        user_square_sum = 1;
        inner_product = additional_item_labo_value ? additional_item_labo_value : 0.8;
    }
    for (let index = 0; index < user_vector.length; index++){
        inner_product += lab_vector[index] * user_vector[index];
    }
    lab_vector.forEach(count => {
        lab_square_sum += count * count;
    })
    user_vector.forEach(count => {
        user_square_sum += count * count;
    })

    //ベクトル長は可変で、内積で適合度を求める場合の処理
    if (setting_yaml != null && setting_yaml.keyword_score_mode != 'COS_VECTOR_LENGTH_FIX' && setting_yaml.keyword_score_mode != 'COS_VECTOR_LENGTH_VARIABLE') {
        const a = setting_yaml.inner_product_regulation_a ? setting_yaml.inner_product_regulation_a : 1;
        const tanhAx = Math.tanh(a * inner_product);
        const tanhA = Math.tanh(a);
        return tanhAx / tanhA;
    }

    if (lab_square_sum != 0  && user_square_sum != 0){
        ans = inner_product / (Math.sqrt(lab_square_sum) * Math.sqrt(user_square_sum));
    }
    return ans;
}

export default Object.freeze({
    similarity,
})